export const initialPaginationState = {
  activePage: 0,
  pageCursors: {},
  itemsPerPage: 25,
  itemsPerPageOptions: [10, 25, 50, 100],
  itemCount: undefined,
};

export default (state, action) => {
  switch (action.type) {
    case 'PAGINATION_INITIALIZE':
      return { ...state, ...action.state };
    case 'PAGINATION_SET_ACTIVE_PAGE':
      return {
        ...state,
        activePage: action.activePage,
      };
    case 'PAGINATION_SET_PAGE_CURSORS':
      return { ...state, pageCursors: action.pageCursors };
    case 'PAGINATION_SET_ITEMS_PER_PAGE':
      return {
        ...state,
        activePage: 0,
        pageCursors: {},
        itemsPerPage: action.itemsPerPage,
      };
    case 'PAGINATION_SET_ITEMS_PER_PAGE_OPTIONS':
      return {
        ...state,
        activePage: 0,
        pageCursors: {},
        itemsPerPageOptions: action.itemsPerPageOptions,
      };
    case 'PAGINATION_SET_ITEM_COUNT':
      return {
        ...state,
        itemCount: action.itemCount,
      };
    case 'PAGINATION_RESET':
      return { ...state, activePage: 0, pageCursors: {} };
    default:
      return { ...state };
  }
};
